import { createBuildUpdateController } from "shared-components";

export const buildUpdateController = createBuildUpdateController({
  clientBuildNumber: VITE_BUILD_NUMBER,
});

buildUpdateController.setApplyUpdate(() => {
  window.location.reload();
});
